import http from "../http";
import Service from "../../Service";

export default class PermissionService extends Service {
    list(params = {}) {
        return http.get("/v2/admin/permissions", {
            headers: this.getHeaders(),
            params,
        });
    }

    create(data) {
        return http.post("/v2/admin/permissions", data, {
            headers: this.getHeaders(),
        });
    }

    update(id, data) {
        return http.put(`/v2/admin/permissions/${id}`, data, {
            headers: this.getHeaders(),
        });
    }

    delete(id) {
        return http.delete(`/v2/admin/permissions/${id}`, {
            headers: this.getHeaders(),
        });
    }

    grantToProfilesWithPermission(id, data) {
        return http.post(`/v2/admin/permissions/${id}/grant-to-profiles-with-permission`, data, {
            headers: this.getHeaders(),
        });
    }
}
